import { normalizeShopProduct } from "./aa-products";

const toNumber = (value, fallback = 0) => {
  const number = Number(value);
  return Number.isFinite(number) ? number : fallback;
};

export function normalizeShopCart(responseData = {}) {
  const data = responseData?.data || responseData || {};
  const items = Array.isArray(data.items) ? data.items : [];

  return {
    items: items.map(normalizeShopCartItem),
    summary: {
      subtotal: toNumber(data.subtotal),
      // Volume discount, server-resolved. Never recompute these in the browser:
      // the JS and PHP dozens helpers round differently and disagree at band
      // boundaries, so the server's numbers are the only correct ones.
      totalDozens: toNumber(data.total_dozens),
      discountPercent: toNumber(data.discount_percent),
      discountAmount: toNumber(data.discount_amount),
      total: toNumber(data.total),
      currency: data.currency || "MXN",
      // Reseller carts only: how much of the cart is beyond warehouse stock, and
      // the admin-configured production lead time to quote for it.
      backorderedQuantity: toNumber(data.backordered_quantity),
      backorderLeadTimeDays: toNumber(data.backorder_lead_time_days)
    }
  };
}

export function getCartVariantColor(item = {}) {
  const color = item?.selectedProductColor ?? item?.variant_color ?? null;
  return color && String(color).trim() ? String(color).trim() : null;
}

export function getCartVariantSize(item = {}) {
  const size = item?.selectedProductSize ?? item?.variant_size ?? null;
  return size && String(size).trim() ? String(size).trim() : null;
}

export function hasCartVariant(item = {}) {
  return Boolean(getCartVariantColor(item) || getCartVariantSize(item));
}

export function formatCartVariantSummary(item = {}) {
  return [getCartVariantColor(item), getCartVariantSize(item)].filter(Boolean).join(" · ");
}

export function normalizeShopCartItem(item = {}) {
  // Wholesale lines keep the flag the product pages set, so the cart and checkout
  // apply the same rules: no stock cap on the quantity, and backorder copy when the
  // line goes past warehouse stock.
  const wholesaleCatalog = Boolean(item.wholesale);
  const product = normalizeShopProduct(item.product || {}, { canBuy: true, wholesaleCatalog });
  const productId = item.product_id ?? product.id;
  const unitPrice = toNumber(item.unit_price ?? product.price);
  const quantity = toNumber(item.quantity, 1);
  const lineTotal = toNumber(item.line_total, unitPrice * quantity);
  const backorderedQuantity = toNumber(item.backordered_quantity);
  const variantColor = item.variant_color ?? null;
  const variantSize = item.variant_size ?? null;

  return {
    ...product,
    id: productId,
    product_id: productId,
    product_variant_id: item.product_variant_id ?? null,
    variant_size: variantSize,
    variant_color: variantColor,
    selectedProductColor: variantColor,
    selectedProductSize: variantSize,
    cartItemId: item.id,
    apiCartItemId: item.id,
    quantity,
    backordered_quantity: backorderedQuantity,
    wholesaleCatalog,
    price: unitPrice,
    unit_price: unitPrice,
    line_total: lineTotal,
    stock: product.stock,
    stock_quantity: product.stock_quantity,
    canBuy: true
  };
}
